<template>
	<div class="main-page">
		<!--<Header :type="type" @search="search" @openRegModal="openRegModal"/>-->
		<header>
		  	<div class="alert alert-warning" v-show="is_show">
		  		您还没有完善供应商信息，所提交的供货信息仅当前浏览器可见。为了便于经销商确认报价并与您取得联系，建议尽快<a href="javascript:;" @click="openEditInfoModal()">完善信息</a>！
		  	</div>
		  	<!--<div class="alert alert-warning">
		  		您还没有完善供应商信息，所提交的供货信息仅当前浏览器可见。为了便于经销商确认报价并与您取得联系，建议尽快<a href="javascript:;" @click="openEditInfoModal()">完善信息</a>！
		  	</div>-->
		  	<div class="header">
		  		<h1>
			    	<router-link :to="{ path: '/' }"></router-link>
			    </h1>
			    <div class="search-img">
			      <input type="text" id="searchInputS" placeholder="搜索商品名称，多个关键词用空格分开" @keyup.enter="search">
			      <button type="button" @click="search">搜索</button>
						<i class="iconfont icon-xiangji" @click="openSearchProByImg"></i>
			    </div>
			    <div class="check-box">
			    	<a href="javascript:;" @click="openRegModal()">我的历史报价信息</a>
			    </div> 
		  	</div>
		</header>
		<section class="filter-box" :class="is_show ? 'showMargin' : ''">
			<p v-if="nameLike != '' && totalCount > 100 && !firstLoading">符合条件的商品约有{{totalCount}}个。结果太多？输入更精准的关键词试试！</p>
			<div class="f-list">
		    	<a v-show="nameLike" href="javascript:;" @click="clearParam('name')">
		     		 商品关键字：
		        	<strong>{{nameLike}}</strong>
		        	<i class=" iconfont icon-close"></i>
		     	</a>
					<a v-show="searchProimgInfo" href="javascript:;" @click="clearParam('searchImg')">
						 以图搜图：
					  	<span v-if="searchProimgInfo.src" class="mg-r-10" style="margin-bottom: 1px;vertical-align: middle;display: inline-block;width: 20px;height: 20px;background-size: 100%;" :style="{backgroundImage: `url(${searchProimgInfo.src})`}"></span>
					  	 <span v-if="searchProimgInfo.imgUrl" class="mg-r-10" style="margin-bottom: 1px;vertical-align: middle;display: inline-block;width: 20px;height: 20px;background-size: 100%;" :style="{backgroundImage: `url(${searchProimgInfo.imgUrl})`}"></span>
					  	<i class=" iconfont icon-close"></i>
					</a>
		    </div>
		</section>
		<!--<filterBox @clearParam="clearParam" :name="nameLike" :type="type" :total="totalCount" :firstLoading="firstLoading"/>-->
		<list :total="totalPage" :keyword="nameLike" :firstLoading="firstLoading" :items="items" :arr="canSupplyIdArr" :last="isLastPage" @canSupply="canSupply"/>
        <InnerLoading v-show="itemsLoading" />
		<!--<footerWrap :type="type" :arr="canSupplyIdArr" @clearCanSupplyId="clearCanSupplyId" @openPageOffer="openPageOffer"/>-->
		<footer>
	        <div>
	          <div id="v-step-0">
	          	<span >
	          		已选 可供货商品 <span>{{canSupplyIdArr.length}}</span> 件
		            <a
		              class=" tx-primary"
		              href="javascript:;"
		              title="清空重选"
		              @click="clearCanSupplyId"
		            >清空</a>
	          	</span>
	          </div>
	          <a
	            id="v-step-1"
	            class="btn btn-primary"
	            href="javascript:;"
	            @click="openPageOffer"
	          >查看待报价商品清单</a>
	        </div>
	    </footer>
		<PageLoading :show="loading" />
		<div class="side-btn" v-show="isVisibleBtn">
	    	<a href="javascript:;" title="引导" @click="startTour">
	        	<i class="iconfont icon-question"></i>
	     	</a>
	    </div>
	    <div class="side-btn2">
	    	<a href="javascript:;" title="引导" @click="startTour">
	        	<i class="iconfont icon-question"></i>
	     	</a>
	    </div>
		<div v-show="isAlertVisible" class="tour-mask">
	      <div>
	        <div>
	          <div>
	            <i class="iconfont icon-success"></i>
	          </div>
	          <div>
	            <p>太好了～您已成功选择了一个可供货的商品！</p>
	            <p>接下来您可以继续选择更多可报价商品，也可以立即提交您的报价！</p>
	          </div>
	        </div>
	        <a
	          class=" btn btn-primary"
	          href="javascript:;"
	          @click="startTour"
	        >下一步</a>
	      </div>
	    </div>
	    <v-tour
	      name="myTour2"
	      :steps="steps"
	      :callbacks="myCallbacks"
	      :options="myOptions"
	    >
	      <template slot-scope="tour">
	        <transition name="fade">
	          <template v-for="(step, index) of tour.steps">
	            <v-step
	              v-if="tour.currentStep === index"
	              :key="index"
	              :step="step"
	              :previous-step="tour.previousStep"
	              :next-step="tour.nextStep"
	              :stop="tour.stop"
	              :is-first="tour.isFirst"
	              :is-last="tour.isLast"
	              :labels="tour.labels"
	            >
	              <template>
	                <div slot="actions">
	                  <button
	                    v-if="tour.currentStep == steps.length - 1"
	                    @click="tour.stop"
	                    class="btn btn-primary"
	                  >我知道了</button>
	                  <button
	                    v-else
	                    @click="tour.nextStep"
	                    class="btn btn-primary"
	                  >下一步</button>
	                </div>
	              </template>
	            </v-step>
	          </template>
	        </transition>
	      </template>
	    </v-tour>
	    <div
	      v-show="isVisibleMask"
	      class="mask"
	    ></div>
			<searchProByImg v-show="isModalVisible"  :open="searchProByImgOpen" @searchProByImgFn="searchProByImgFn" :load="searchLoading" @close="close"></searchProByImg>
	</div>
</template>

<script>
import Header from "./../components/header.vue";
import filterBox from "./../components/filter.vue";
import list from "./../components/list.vue";
import footerWrap from "./../components/footer.vue";
import InnerLoading from "./../components/innerLoading";
import PageLoading from "./../components/pageLoading";
import searchProByImg from './../components/search-pro-by-img.vue';//以图搜图
export default {
	props:["is_show"],
  data() {
    return {
    	searchType:"ph",
    	type:1,
    	loading: false,
      	firstLoading: true,
      	itemsLoading: false,
      	page: 1,
      	rowsPerPage: 20,
      	totalCount: 0,
      	items: [],
      	totalPage: 1,
      	isLastPage: false,
      	canSupplyIdArr: [],
      	canSupplyItems: [],
      	nameLike:"",
      	isAlertVisible: false,
      	myOptions: {
          useKeyboardNavigation: false,
        },
      	steps: [
	        {
	          target: "#v-step-0",
	          content: "这里是您即将要报价的商品数量"
	        },
	        {
	          target: "[data-type=btn]",
	          content: "您也可以继续选择要报价的商品"
	        },
	        {
	          target: "#v-step-1",
	          content: "点此立即填写报价"
	        }
	    ],
	    myCallbacks: {
	        onStart: () => {
	          this.isVisibleMask = true;
	          $("body").addClass("overflow-y-hidden");
	        },
	        onStop: () => {
	        	$("body").removeClass("overflow-y-hidden");
	          localStorage.setItem("knowTourPro", 1);
	          this.isVisibleBtn = localStorage.getItem("knowTourPro") ? localStorage.getItem("knowTourPro") : "";
	          this.tourClose();
	        }
	    },
	    isVisibleMask: false,
	    isVisibleBtn: localStorage.getItem("knowTourPro") ? localStorage.getItem("knowTourPro") : "",
			isModalVisible: false,
			searchProByImgOpen:Symbol(),
			searchProimgInfo:"",
			searchLoading:false
    };
  },
  components: {
	  searchProByImg,
    Header,
    filterBox,
    list,
    footerWrap,
    InnerLoading,
    PageLoading,
  },
  mounted() {
  	this.getList("");
  	window.addEventListener("scroll", e => {
      this.scrollGetList(this.searchProimgInfo);
    });
    this.canSupplyIdArr = JSON.parse(localStorage.getItem("canSupplyIdArrs"))
      ? JSON.parse(localStorage.getItem("canSupplyIdArrs"))
      : [];
    this.canSupplyItems = JSON.parse(localStorage.getItem("canSupplyItems"))
      ? JSON.parse(localStorage.getItem("canSupplyItems"))
      : [];
    window.addEventListener("storage",(e) =>{
  		if(localStorage.getItem('canSupplyIdArrs')){
  			this.canSupplyIdArr = JSON.parse(localStorage.getItem("canSupplyIdArrs"));
  			this.canSupplyItems = JSON.parse(localStorage.getItem("canSupplyItems"));
    	}
  	});
//	document.onkeydown  = this.keydown(event);
  },
  watch: {
  },
  methods: {
		searchProByImgFn(info,searchFlag){
			let imgInfo = {
				base64:info.base64,
				ext:info.ext,
				imgUrl:info.imgUrl,
				src:info.src
			};
			this.$apiCall("api.DistributorProduct.searchByImg",{
				imageBase64:imgInfo.base64,
				imageBase64Suffix:imgInfo.ext,
				imgUrl:imgInfo.imgUrl,
				type:3,
				searchType:this.searchType
			},r=>{
				if (r.data.ErrorCode == "9999") {
					imgInfo.imgVal = r.data.Data.Results.imgVal;
					this.getList(imgInfo,searchFlag);
				} else {
					this.searchLoading = false;
					this.searchProByImgOpen = Symbol();
					 this.$toasted.show(
					   `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
					   {
						 theme: "primary",
						 position: "top-center",
						 className: "danger",
						 duration: this.page == 1 ? 9999999 : 3000
					   }
					 );
				}
			})
		},
		close(){
			this.isModalVisible = false;
		},
		openSearchProByImg(){
				  this.searchProByImgOpen = Symbol();
					  this.isModalVisible = true;
		},
  	tourClose(){
  		this.isVisibleMask = false;
  		$(".side-btn2").show().animate({
			"right":"2px","bottom":"180px"
		},600,function(){
			$(".side-btn2").css({"right":"80px","bottom":"80px"}).hide();
		});
  	},
  	openEditInfoModal(){
  		this.$emit("openEditInfoModal");
  	},
  	openRegModal(type){
  		this.$emit("openRegModal",this.type);
  	},
		clearParam(type) {
		  switch (type) {
		    case "name":
		       this.nameLike = "";
		       document.getElementById("searchInputS").value = "";
		      break;  
				case "searchImg":
					this.searchProimgInfo = "";
				break;	
		  }
		  this.page = this.totalPage = 1;
		  this.itemsLoading = false;
		  this.firstLoading = true;
		  this.items = [];
		  this.getList(this.searchProimgInfo);
		},
  	search() {
      this.nameLike = document.getElementById("searchInputS").value;
      this.page = this.totalPage = 1;
      this.itemsLoading = false;
      this.firstLoading = true;
      this.items = [];
      this.getList(this.searchProimgInfo);
    },
  	getList(imgInfo,searchFlag) {
			this.searchProimgInfo = imgInfo?imgInfo:"";
			if(searchFlag){
				this.items = [];
				this.page = 1;
			}
      if (this.itemsLoading) return;
      if (this.page > this.totalPage) {
        this.isLastPage = true;
        return;
      }
      this.itemsLoading = true;
      let params = {
      	searchType:this.searchType,
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        nameLike: this.nameLike,
        supplierId: JSON.parse(localStorage.getItem("supplierPriceInfo")) ? JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId : "",
				imgVal:  this.searchProimgInfo ? this.searchProimgInfo.imgVal : "",
      };
      this.$apiCall("api.OfferProduct.findsBySupplier", params, r => {
        this.itemsLoading = false;
        this.firstLoading = false;
        if (r.data.ErrorCode == "9999") {
          r.data.Data.Results.forEach(item => {
            this.items.push(item);
          });
					if(searchFlag){
						this.isModalVisible = false;
					}
          this.totalCount = r.data.Data.Pagination.totalCount;
          this.totalPage = r.data.Data.Pagination.totalPage;
          this.page++;
          setTimeout(() => {
            this.scrollGetList(this.searchProimgInfo);
          }, 100);
          setTimeout(() => {
            this.$previewRefresh(); //重置图片预览
          }, 200);
        } else {
          this.$toasted.show(
            `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
            {
              theme: "primary",
              position: "top-center",
              className: "danger",
              duration: this.page == 1 ? 9999999 : 3000
            }
          );
        }
      });
    },
    scrollGetList(searchProimgInfo) {
      let scrollT =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollT + window.innerHeight >= document.body.offsetHeight - 300) {
        this.getList(searchProimgInfo);
      }
    },
    clearCanSupplyId() {
      //清空选择的商品
      this.canSupplyIdArr = [];
      this.canSupplyItems = [];
      localStorage.setItem("canSupplyIdArrs", JSON.stringify(this.canSupplyIdArr));
  	  localStorage.setItem("canSupplyItems", JSON.stringify(this.canSupplyItems));
    },
    canSupply(val) {
      	this.canSupplyIdArr.push(val);
	  	this.items.forEach((s)=>{
  			if(val == s.id){
  				this.canSupplyItems.push(s);
  			}
		})
	  	localStorage.setItem("canSupplyIdArrs", JSON.stringify(this.canSupplyIdArr));
  		localStorage.setItem("canSupplyItems", JSON.stringify(this.canSupplyItems));
      	this.scrollGetList("");
      	//开始tour
      	if (!localStorage.getItem("knowTourPro")) this.isAlertVisible = true;
    },
    startTour(){
      this.isAlertVisible = false;
      if(document.querySelectorAll('[data-type=btn]').length == 0){
        this.steps.splice(1,1);
      }
      this.$tours["myTour2"].start();
//    $("body").addClass("overflow-y-hidden");
    },
    openPageOffer(){
    	if (this.canSupplyIdArr.length < 1) {
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 请先选择能供货商品`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        return;
	    }
    	this.$router.push({ name: 'pageOffer', params: { ids: this.canSupplyIdArr,items:this.items,canItems:this.canSupplyItems }})
    },
  }
};
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.3);
}
body .v-step {
  background-color: @white;
  color: @black-1;
  max-width: 360px;
}
.total-count {
  color: @gray-1;
}
.tour-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.3);
  > div {
    > div {
      display: flex;
      align-items: center;
      text-align: left;
      margin-bottom: 15px;
      p{
        margin: 0 0 5px 0;
      }
      p:last-child{
        color: @gray-1;
        font-size: 14px;
      }
    }
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    background-color: @white;
    text-align: center;
    i {
      margin-right: 25px;
      color: @primary;
      font-size: 64px;
    }
  }
}
.side-btn{
  position: fixed;
  right: 2px;
  bottom: 180px;
  a{
    display: block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: @white;
    border: 1px solid @b-c-gray;
    color: @gray;
    i{
      font-size: 22px;
    }
  }
  a:hover{
    color: @primary;
  }
}
.side-btn2{
	position: fixed;
  	right: 80px;
    bottom: 80px;
    display: none;
  	a{
    display: block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: @primary;
    border: 1px solid @b-c-gray;
    color: @white;
    i{
	      font-size: 22px;
	    }
	  }
	  a:hover{
	    color: @primary;
	  }
}
.search-img{
	position: relative;
	i{
		font-size: 20px;
    position: absolute;
    top: 5px;
    right: 75px;
    color: #666;
		cursor: pointer;
	}
}
</style>